/*
 * GoalListControls.jsx 05.02.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withRouter} from 'react-router';

import GoalList from '../../components/detail/GoalList';
import {countDeadlineExceeded, countNearDeadline, getGaps} from '../../utils';
import {compareAsc} from 'date-fns';

class GoalListControls extends React.Component {

    /**
     * Überprüft die Ziele nach Hinweis- und Warnmeldungen, hängt die Meldungen an den einzelnen Ziele an und gibt sie zusätzlich als Liste zurück.
     *
     * @return {Map} Eine Map mit allen Meldungen (Warn- und Hinweismeldungen) zu den Zielen. Als Key wird die Ziel-ID verwendet. Hinter dem Value verbirgt sich ein Array mit
     * allen Meldungen zum Ziel. Unter dem Key '0' werden allgemeine Fehler gehalten.
     */
    prepareNotification() {
        const goalList = this.props.goalList;
        const goalNotifactionMap = new Map();

        goalList.forEach(g => {
            const notifactions = [];

            if (countDeadlineExceeded([g])) {
                notifactions.push({
                    type: 'warning',
                    message: 'Zielfrist überschritten!'
                });

            } else if (countNearDeadline([g])) {
                notifactions.push({
                    type: 'hint',
                    message: 'Zielfrist bald erreicht!'
                });
            }

            if (!g.schrittVorhanden) {
                notifactions.push({
                    type: 'warning',
                    message: 'Schrittdokumentation prüfen!'
                });
            }


            if (notifactions.length > 0) {
                goalNotifactionMap.set(g.id, notifactions);
            }
        });

        // Generelle Hinweismeldungen zum Teilnehmer werden unter dem Map-Key '0' abgelegt.
        const participantNotifications = [];
        if (goalList.filter(g => !g.zielerreicht).length === 0) {
            participantNotifications.push({
                type: 'warning',
                message: 'Es sind keine offenen Ziele hinterlegt!'
            });
        }

        if (participantNotifications.length > 0) {
            goalNotifactionMap.set(0, participantNotifications);
        }

        return goalNotifactionMap;
    }

    /**
     * Bedient das Selektieren eines neuen Ziels durch den Benutzer.
     *
     * @param {Object} goal das zu selektierende Ziel
     */
    handleSelectGoal(goal) {
        const location = {
            pathname: `/participant/${this.props.participant.id}/${goal.id}`
        };

        this.props.history.push(location);
    }

    /**
     * Wenn das ausgewählte Ziel gelöscht, soll auch der Path angepasst werden
     *
     */
    handleGoalDeletion() {
        const location = {
            pathname: `/participant/${this.props.participant.id}/`
        };

        this.props.history.push(location);
    }


    render() {
        const {participant, goalList, selectedGoal} = this.props,
            notificationMap = this.prepareNotification();


        const gapsWithoutWeekends = getGaps(goalList),
            goalListCopy = [...goalList];

        for (const gap of gapsWithoutWeekends) {
            goalListCopy.push({
                id: `gap-${Math.random()}`,
                anfang: gap.anfang,
                ende: gap.ende
            });
        }

        goalListCopy.sort((a, b) => compareAsc(a.ende, b.ende));

        if (goalList.length !== 0 && goalList.filter(g => g.id === this.props.match.params.goalId).length === 0) {
            this.handleGoalDeletion();
        }

        return (
            <GoalList hasGap={gapsWithoutWeekends.length > 0} participant={participant} goalList={goalListCopy} selectedGoal={selectedGoal} notificationMap={notificationMap}
                onSelectGoal={this.handleSelectGoal.bind(this)}/>
        );
    }
}


export default withRouter(GoalListControls);



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/detail/GoalListControls.js